import { Stack } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal, Text } from '@feathr/components';

interface IPrototypeDoneModalProps {
  description?: string;
  onClose: () => void;
  opened: boolean;
  title: string;
}

function PrototypeDoneModal({
  description,
  onClose,
  opened,
  title,
}: Readonly<IPrototypeDoneModalProps>): JSX.Element {
  const { t } = useTranslation();
  return (
    <Modal
      onClose={onClose}
      opened={opened}
      rightActions={
        <Button onClick={onClose} type={'primary'}>
          {t('Close')}
        </Button>
      }
      title={title}
    >
      <Stack>
        <Text variant={'defaultRegular'}>
          {description ?? t('The prototype ends here. The real workflow opens at this point.')}
        </Text>
      </Stack>
    </Modal>
  );
}

export default PrototypeDoneModal;
